import {decrypt} from "../../utils/crypto";
import moment from "moment/moment";
import {setDataList} from "../../../apps/KpModule/actions";

const _ = require('lodash')
const crypto = require('crypto')
const {fieldPathJoinGetter} = require('../../utils/kp3Utils')
const { sendMail } = require('./mails/userInitialization')
const {validateButton, saveButton, returnButton} = require('./utils')
const Errors = require('../../utils/Errors').default
const {basicContext} = require('../../utils/contextUtils')
const { generateFetchFieldListAction } = require('../../../apps/KpModule/actions/api')
const {setFieldVisibility} = require('../../../apps/KpModule/actions')

export const entities = [
    {
        name: 'CUser',
        facets: ['files', 'conversations'],
        fields: [
            {path: 'civility', type: 'NewCivility', nullable: true},
            {path: 'firstname', nullable: true},
            {path: 'lastname', nullable: true},
            {type: 'Language', nullable: true},
            {path: 'phone', encrypted: true},
            {path: 'phone2', encrypted: true},
            //deleted
            //{path: 'phone3', encrypted: true},
            {path: 'kpUser', type: 'User', nullable: true},
            {path: 'active', type: 'boolean', nullable: true},
            {path: 'superCom_', type: 'boolean', nullable: true},
            {path: 'mail', unique: true, encrypted: true},
            {path: "username", unique: true},
            //{type: 'Organization', nullable: true},
            {path: 'organizationReferent', type: 'boolean'},
            {path: 'liberalityReferent', type: 'boolean'},
            {type: 'Function', link: "MTM", nullable: true},
            {path: 'shelters', type: 'Shelter', link: "MTM", nullable: true},
            {type: 'AnimalType', link: 'MTM', nullable: true},
            {path: 'authorizations', type: 'Profile', link: 'MTM', nullable: true},
            'status',
            { path: 'lastUser', type: 'User', nullable: true },
            { path: 'lastModificationDate', type: 'date', nullable: true },
            {
                path: 'organizationZipCode',
                fieldPath: ['organization.zipCode'],
                f: function() {
                    return this.organization?.zipCode
                }
            },
            {
                path: 'organizationZone',
                fieldPath: ['organization.zone.id'],
                f: function() {
                    return this.organization?.zone
                }
            },
            {
                path: 'organizationName',
                fieldPath: ['organization.name'],
                f: function() {
                    return this.organization?.name
                }
            },
            {
                path: 'organizationTradingName',
                fieldPath: ['organization.tradingName'],
                f: function() {
                    return this.organization?.tradingName
                }
            },
            {
                path: 'organizationType',
                fieldPath: ['organization.organizationType.id'],
                f: function() {
                    return this.organization?.organizationType
                }
            },
            {
                path: 'organizationStatus',
                fieldPath: ['organization.status.id'],
                f: function() {
                    return this.organization?.status
                }
            },
            {
                path: 'organizationStatus',
                fieldPath: ['organization.status.id'],
                f: function() {
                    return this.organization?.status
                }
            },
            {
                path: 'organizationAnimalTypes',
                fieldPath: ['organization.animalTypes.id'],
                f: function() {
                    return this.organization?.animalTypes
                }
            },
            {
                path: 'organizationActivities',
                fieldPath: ['organization.activities.id'],
                f: function() {
                    return this.organization?.activities
                }
            },
            {
              path: 'establishmentsZipCodes',
              fieldPath: ['organization.establishments.id', 'organization.establishments.zipCode'],
                f: function() {
                    return this.organization?.establishments?.map(establishment => establishment.zipCode)
                }
            },
            {
              path: 'sheltersZipCodes',
              fieldPath: ['organization.refuges.id', 'organization.refuges.zipCode'],
                f: function() {
                    return this.organization?.refuges?.map(refuge => refuge.zipCode)
                }
            },
            {
                path: 'contributionsStatus',
                fieldPath: ['organization.organizationMemberships.exercise.exerciseStatus', 'organization.organizationMemberships.status.id'],
                f: function() {
                    const ongoingMembership = this.organization?.organizationMemberships?.find(om => _.get(om, 'exercise.exerciseStatus.id') === 'ongoing')
                    return ongoingMembership?.status?.id === 'settled' ? {id: 'upToDate'} : {id: 'notUpToDate'}
                }
            },
            {
                path: 'unsubscribed',
                type: 'boolean',
                fieldPath: ['kpUser.unsubscribed'],
                f: function() {
                    return !!this.kpUser?.unsubscribed
                }
            },
            {
                path: 'isOrganizationReferent',
                fieldPath: ['organizationReferent'],
                f: function() {
                    return !!this.organizationReferent ? {id: 'yes'} : {id: 'no'}
                }
            },
            {
                path: 'isLiberalityReferent',
                fieldPath: ['liberalityReferent'],
                f: function() {
                    return !!this.liberalityReferent ? {id: 'yes'} : {id: 'no'}
                }
            },
            fieldPathJoinGetter({
                path: "fullName",
                fieldPath: ["firstname", "lastname"],
                joinString: " "
            }),
            {
                path: 'completeInfo',
                fieldPath: ['civility.name', 'fullName', 'mail', 'phone'],
                $f: function(user, context, callback){
                    if(!context.tc) context.tc = t => _.upperFirst(t)
                    const civility = _.get(user, 'civility.name', '')
                    const mail = user.mail && decrypt(user.mail)
                    const phone = user.phone && decrypt(user.phone)
                    return callback(null, `${context.tc(civility)} ${user.fullName}, Courriel : ${mail} et Téléphone : ${phone}`)
                }
            },
            {
                path: 'buttons',
                $f: function (user, context, callback) {
                    if(context.clientContext?.moduleId === 'm-C-information') {
                        return callback(null, [saveButton, returnButton])
                    }

                    if(context.clientContext?.moduleId === 'm-C-users') {
                        if(user.status === 'waiting') return callback(null, [validateButton, saveButton, returnButton])
                    }

                    return callback(null, [saveButton, returnButton])
                }
            }
        ],
        filters: [
            {
                name: "isActive",
                isDefault: false,
                query: () => ({active: true})
            },
            {
                name: "byUser",
                isDefault: false,
                query: function(context) {
                    const user = context.user
                    if(user) return {kpUser: new global.ObjectID(user.id)}
                }
            },
            {
                name: "byOrganization",
                isDefault: false,
                async: true,
                query: function(context, callback) {
                    const user = context.user
                    global.app.C.CUser.get({kpUser: new global.ObjectID(user.id)}, {
                        ...basicContext(context),
                        fieldPath: ['id', 'organization.id']
                    }, (error, cUser) => {
                        if(error) return callback(error)
                        callback(null, {organization: new global.ObjectID(cUser.organization.id)})
                    })
                },
            },
            {
                name: "byOrganizationId",
                isDefault: false,
                query: (context) => {
                    const organizationId = _.get(context, 'data.organizationId')
                    return organizationId
                        ? {organization: new global.ObjectID(organizationId)}
                        : {_id: null}
                }
            },
            {
                name: "onlyActiveUsers",
                isDefault: false,
                query: () => ({active: true})
            },
            {
                name: "eligibleToVisit",
                isDefault: false,
                async: true,
                query: function(context, callback) {
                    global.app.C.Function.find({
                        ...basicContext(context),
                        query: {eligibleToVisit: true},
                        fieldPath: ['id']
                    }, (error, functions) => {
                        if(error) return callback(error)
                        callback(null, {functions: {$elemMatch: {$in: functions.map(f => new global.ObjectID(f.id))}}})
                    })
                },
            },
            {
                name: "eligibleToLiberalityProcess",
                isDefault: false,
                async: true,
                query: function(context, callback) {
                    global.app.C.Function.find({
                        ...basicContext(context),
                        query: {liberalityProcessAdministrator: true},
                        fieldPath: ['id']
                    }, (error, functions) => {
                        if(error) return callback(error)
                        callback(null, {functions: {$elemMatch: {$in: functions.map(f => new global.ObjectID(f.id))}}})
                    })
                },
            },
            {
                name: "fromSupplierOrganization",
                isDefault: false,
                async: true,
                query: async function(context, callback) {
                    try {
                        const supplierOrgs = await global.app.C.Organization.find({
                            ...basicContext(context),
                            fieldPath: ['id'],
                            query: {organizationType: 'supplier'}
                        })
                        callback(null, {organization: {$in: supplierOrgs.map(org => new global.ObjectID(org.id))}})
                    } catch(e) {
                        callback(e)
                    }
                }
            }
        ],
        beforeSave: async function (newObject, oldObject, context, callback) {

            newObject.lastUser = new global.ObjectID(context.user.id)
            newObject.lastModificationDate = new Date()

            const action  = context.restAction && context.restAction.crudType
            const profiles = newObject.authorizations
                ? newObject.authorizations.map(auth => new global.ObjectID(auth.id))
                : []

            const currentGroup = new global.ObjectID(context.group.id)
            const currentGroupModel = new global.ObjectID(context.groupModel.id)


            if(action === 'C') {
                newObject.status = 'waiting'
                newObject.language = {id: 'fr', name: 'Français'}
                if(context.clientContext.moduleId === 'm-C-information') {
                    const cUser = await global.app.C.CUser.get({kpUser: new global.ObjectID(context.user.id)}, {
                        ...basicContext(context),
                        fieldPath: ['id', 'organization.id']
                    })

                    if(!cUser) return callback(new Error('permissionToCreateUserDenied'))
                    newObject.organization = _.clone(cUser.organization)
                }
            }

            if (context.action === 'validate'){
                if (!newObject.mail) return callback(new Errors.ValidationError("Le courriel est obligatoire pour la validation d'un contact"))
            }

            if(newObject.status === 'validated') {
                const userObject = {
                    ..._.pick(newObject, ['civility', 'firstname', 'lastname', 'username', 'mail', 'phone', 'active']),
                    language: _.get(newObject, 'language.id'),
                    'groups.$[elem1].groupModels.$[elem2].superCom_': !!newObject.superCom_,
                    'groups.$[elem1].groupModels.$[elem2].profiles': profiles
                }

                const arrayFilters = [{ 'elem1.group': currentGroup }, { 'elem2.groupModel': currentGroupModel }]

                if(newObject.mail.toUpperCase() !== oldObject.mail.toUpperCase()) {
                    crypto.randomBytes(20, (err, buf) => {
                        if (err) callback(err)
                        const token = buf.toString('hex')

                        userObject.resetPasswordToken = token
                        userObject.resetPasswordExpires = Date.now() + 86400000

                        global.User.collection.updateOne(
                            { _id: new global.ObjectID(oldObject.kpUser) },
                            { $set: userObject },
                            { arrayFilters }
                        ).then(() => {
                            sendMail(token, userObject, context, (error, msg) => {console.log(msg)})
                            callback(null, newObject, oldObject)
                        }).catch(e => callback(e))
                    })
                } else {
                    global.User.collection.updateOne(
                        {_id: new global.ObjectID(oldObject.kpUser)},
                        { $set: userObject },
                        { arrayFilters }
                    ).then(() => callback(null, newObject, oldObject)).catch(e => callback(e))
                }
            } else if(newObject.status === 'waiting' && context.action === 'validate') {

                const buf = crypto.randomBytes(20);
                const token = context.customToken || buf.toString('hex')

                const baseUserFields = {
                    ..._.pick(newObject, ['civility', 'firstname', 'lastname', 'username', 'mail', 'phone', 'active']),
                    language: _.get(newObject, 'language.id'),
                    resetPasswordToken: token,
                    resetPasswordExpires: Date.now() + 86400000,
                }

                const newGroupEntry = {
                    group: currentGroup,
                    super_: false,
                    superAF_: false,
                    superCom_: !!newObject.superCom_,
                    groupModels: [{ groupModel: currentGroupModel, super_: false, profiles }]
                }

                try {
                    const existingUser = await global.User.collection.findOne({ mail: newObject.mail })

                    let userId
                    if (!existingUser) {
                        const result = await global.User.collection.insertOne({ ...baseUserFields, groups: [newGroupEntry] })
                        userId = result.insertedId
                    } else {
                        userId = existingUser._id
                        const hasGroup = existingUser.groups?.some(g => g.group.toString() === currentGroup.toString())

                        if (hasGroup) {
                            await global.User.collection.updateOne(
                                { _id: userId },
                                {
                                    $set: {
                                        ...baseUserFields,
                                        'groups.$[elem1].groupModels.$[elem2].superCom_': !!newObject.superCom_,
                                        'groups.$[elem1].groupModels.$[elem2].profiles': profiles
                                    }
                                },
                                { arrayFilters: [{ 'elem1.group': currentGroup }, { 'elem2.groupModel': currentGroupModel }] }
                            )
                        } else {
                            await global.User.collection.updateOne(
                                { _id: userId },
                                {
                                    $set: baseUserFields,
                                    $push: { groups: newGroupEntry }
                                }
                            )
                        }
                    }

                    newObject.kpUser = { id: userId.toString() }

                    if (!context.customPasswordInitializationMail) {
                        sendMail(token, baseUserFields, context, (error, msg) => { console.log(msg) })
                    }

                    newObject.status = 'validated'
                    return callback(null, newObject, oldObject)
                } catch(e) {
                    return callback(e)
                }

            } else if(newObject.status === 'waiting') {
                return callback(null, newObject, oldObject)
            }
            else callback(new Errors.ValidationError('Statut utilisateur inéxistant'))
        },
        afterDelete: async function (object, context, callback) {
            const kpUser = await global.User.collection.findOne({_id: object.kpUser})
            if(!kpUser) return callback()
            if(kpUser.groups.length === 0) {
                await global.User.collection.deleteOne({_id: object.kpUser})
                return callback()
            }
            if(kpUser.groups.length === 1 && kpUser.groups[0].groupModels.length <= 1 ) {
                if(kpUser.groups[0].groupModels.length === 0) {
                    await global.User.collection.deleteOne({_id: object.kpUser})
                    return callback()
                }
                if(kpUser.groups[0].group.toString() === context.group.id && kpUser.groups[0].groupModels[0].groupModel.toString() === context.groupModel.id) {
                    await global.User.collection.deleteOne({_id: object.kpUser})
                    return callback()
                }
            }
            const filteredGroups = kpUser.groups.map(
                group => {
                    if(group.group.toString() !== context.group.id) return group
                    if(!group.groupModels) return group
                    const filteredGroupModels = group.groupModels.filter(groupModel => groupModel.groupModel.toString() !== context.groupModel.id)
                    if(filteredGroupModels.length === 0) return null
                    return ({
                        ...group,
                        groupModels: filteredGroupModels
                    })
                }
            )

            await global.User.collection.updateOne(
                {_id: object.kpUser},
                {
                    $set: {groups: _.compact(filteredGroups)}
                }
            )

            return callback()
        }
    }
]

export const administratorModule = {
    name: 'Users',
    object: 'CUser',
    tKey: 'mTitle_user',
    objectIdentifier: 'mail',
    defaultSortBy: 'lastname',
    defaultSortDirection: 'ASC',
    protectedExport: true,
    category: {
        path: 'menuTitle_phoneBook',
        icon: 'notebook'
    },
    formSections: [
        {
            id: 'chat',
            tKey: "Historique d'échanges",
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        }
    ],
    viewMap: {
        dt: [
            {path: 'organization.organizationType.name', tKey: 'type organisation', initiallyNotVisible: true},
            {path: 'organization', initiallyNotVisible: true},
            {path: 'civility', tKey: 'civility_spec', initiallyNotVisible: true},
            'lastname',
            'firstname',
            'mail',
            {path: 'username', initiallyNotVisible: true},
            {path: 'phone', tKey: 'phone_spec'},
            {path: 'phone2', initiallyNotVisible: true},
            {path: 'organizationReferent', tKey: 'organizationReferent_spec', initiallyNotVisible: true},
            {path: 'liberalityReferent', tKey: 'liberalityReferent_spec', initiallyNotVisible: true},
            {path: 'shelters', tKey: 'establishments_contact', initiallyNotVisible: true},
            {path: 'functions', tKey: 'jobs_spec'},
            {path: 'authorizations', tKey: 'profiles_spec', translateName: true},
            {path: 'status', translate: true},
            {path: 'active', tKey: 'activeUser', width: 100},
            {path: "superCom_", tKey: 'comAdmin', width: 100},
            {path: 'unsubscribed', tKey: 'Désabonné des communications', width: 100},
            {path: 'lastUser'},
            {path: 'lastModificationDate'},
        ],
        form: {
            fields: [
                {
                    path: 'organization',
                    editable: false,
                    display: 'fullName',
                    required: true,
                    fieldPath: ['id', 'fullName', 'organizationType.id', 'status.id'],
                    subscriptions: {
                        onChange: (newValue, oldValue, {module, store}) => {
                            store.dispatch(generateFetchFieldListAction(
                                'm-C-users.CUser_shelters',
                                store.getState,
                                {
                                    data: {
                                        organizationId: newValue?.id
                                    }
                                }

                            ))

                            const isMemberAssociation = newValue?.organizationType?.id === 'association' //&& newValue?.status?.id === 'member'

                            store.dispatch(setFieldVisibility('e_organizationReferent', !!isMemberAssociation))
                            store.dispatch(setFieldVisibility('e_liberalityReferent', !!isMemberAssociation))
                        }
                    }
                },
                {path: 'civility', tKey: 'civility_spec', required: true, sortList: false},
                {path: 'lastname', uppercase: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'firstname', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'mail', lowercase: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'username', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'phone', tKey: 'phone_spec', type: 'phoneNumber', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'phone2', type: 'phoneNumber', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'organizationReferent', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'liberalityReferent', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'language', hidden: true},
                {
                    path: 'shelters',
                    tKey: 'establishments_contact',
                    display: 'siretNameStatus',
                    fieldPath: ['id', 'name', 'animalTypes.id', 'siretNameStatus'],
                    filters: ['byOrganizationAndNotClosed']
                },

                {path: 'functions', tKey: 'jobs_spec'},
                {path: 'authorizations', tKey: 'profiles_spec', translateName: true, required: true, filters: ['thisModel']},
                {path: 'active', tKey: 'activeUser', default: true},
                {path: "superCom_", tKey: 'comAdmin', default: false},
                {path: 'unsubscribed', tKey: 'Désabonné des communications', disabled: true},
                {path: 'conversations', section: 'chat', tKey: "interactionZone"},
                {path: 'buttons', hidden: true},
                {path: 'status', hidden: true},
            ]
        }
    }
}

export const userModule = {
    name: 'Information',
    object: 'CUser',
    tKey: 'mTitle_information',
    objectIdentifier: 'mail',
    defaultSortBy: 'lastname',
    defaultSortDirection: 'ASC',
    protectedExport: true,
    category: {
        path: 'menuTitle_myAssociation',
        icon: 'building'
    },
    viewMap: {
        dt: [
            {path: 'civility', tKey: 'civility_spec', initiallyNotVisible: true},
            'lastname',
            'firstname',
            'mail',
            {path: 'username', initiallyNotVisible: true},
            {path: 'phone', tKey: 'phone_spec'},
            {path: 'phone2', initiallyNotVisible: true},
            {path: 'organizationReferent', tKey: 'organizationReferent_spec', initiallyNotVisible: true},
            {path: 'liberalityReferent', tKey: 'liberalityReferent_spec', initiallyNotVisible: true},
            {path: 'shelters', tKey: 'establishments_contact', initiallyNotVisible: true},
            {path: 'functions'},
            {path: 'authorizations', tKey: 'profiles_spec', translateName: true, initiallyNotVisible: true},
            {path: 'status', translate: true},
            {path: 'active', tKey: 'activeUser', width: 100},
            {path: 'unsubscribed', tKey: 'Désabonné des communications', width: 100},
            {path: 'lastUser'},
            {path: 'lastModificationDate'},
            {path: 'noDeleteButtonAccess', hidden: true},
        ],
        form: [
            {path: 'civility', tKey: 'civility_spec', required: true, sortList: false},
            {path: 'lastname', uppercase: true, widthClassName: "col-xs-12 col-sm-6"},
            {path: 'firstname', widthClassName: "col-xs-12 col-sm-6"},
            {path: 'mail', required: true, lowercase: true, widthClassName: "col-xs-12 col-sm-6"},
            {path: 'username', widthClassName: "col-xs-12 col-sm-6"},
            {path: 'phone', tKey: 'phone_spec', type: 'phoneNumber', widthClassName: "col-xs-12 col-sm-6"},
            {path: 'phone2', type: 'phoneNumber', widthClassName: "col-xs-12 col-sm-6"},
            {
                path: 'shelters',
                fieldPath: ['id', 'name', 'animalTypes.id'],
                filters: ['byUserOrganization'],
                tKey: 'establishments_contact'
            },
            {path: 'functions', filters: ['eligibleToAssociation']},
            {path: 'active', tKey: 'activeUser', default: true},

            {path: 'language', hidden: true},
            {path: 'organization', hidden: true},
            {path: 'status', hidden: true},
            {path: 'buttons', hidden: true},
        ],
    },
    filters: [
        'byOrganization'
    ]
}
